import React from 'react';

import Button from 'devextreme-react/button';

import DataModelView from '../common/view/DataModelView';

import MemoEditorView from './MemoEditorView'

import './MemoPaneView.css';

export default class MemoPaneView extends DataModelView {
  constructor(props) {
    super(props);

    this.clickOpenEditorHandler = this.onClickOpenEditor.bind(this);
    this.clickCloseHandler = this.onClickClose.bind(this);
    this.clickCreateHandler = this.onClickCreate.bind(this);
    this.clickSaveHandler = this.onClickSave.bind(this);
    this.clickRevertHandler = this.onClickRevert.bind(this);
  }

  getIntegratedPropertyNames() {
    return [
      'allowEditMode',
      'editModeActive',
      'isModified',
      'memoDataModels'
    ];
  }

  render() {
    if (this.state.memoDataModels === undefined)
      return (<div></div>)

    return (
      <div>
        {this.state.allowEditMode
          ? this.state.editModeActive
            ? this.renderEditModeActive()
            : this.renderEditModeInactive(this.state.memoDataModels.length)
          : this.renderReadOnlyMode()
        }
        {this.state.memoDataModels.map(dataModel => (
          <MemoEditorView key={dataModel.guid} editModeActive={this.state.editModeActive} dataModel={dataModel} />
        ))}
      </div>
    );
  }

  renderReadOnlyMode() {
    return (<div />);
  }

  renderEditModeActive() {
    return (
      <div className="pwx-memo-notes-editor-bar">
        <Button
          type="normal"
          icon="add"
          hint="Create New Memo"
          text="New"
          onClick={this.clickCreateHandler}
          visible={true}
        />
        <div className="pwx-memo-notes-editor-button-gap" />
        <Button
          type="normal"
          disabled={!this.state.isModified}
          icon="save"
          hint="Save All Changes"
          text="Save"
          onClick={this.clickSaveHandler}
          visible={true}
        />
        <div className="pwx-memo-notes-editor-button-gap" />
        <Button
          type="normal"
          disabled={!this.state.isModified}
          icon="revert"
          hint="Revert All Changes"
          text="Revert"
          onClick={this.clickRevertHandler}
          visible={true}
        />
        <div className="pwx-memo-notes-editor-button-spring-gap" />
        <Button
          type="normal"
          icon="check"
          hint="Close Editor"
          text="Close"
          onClick={this.clickCloseHandler}
          visible={true}
        />
      </div>
    );
  }

  renderEditModeInactive(memoCount) {
    return (
      <div className="pwx-memo-notes-editor-bar">
        {memoCount > 0
          ? (
            <Button
            type="normal"
            icon="edit"
            hint="Memo Visibility"
            text="Edit Memos..."
            onClick={this.clickOpenEditorHandler}
            visible={true}
          />)
          : (
            <Button
            type="normal"
            icon="add"
            hint="Create New Memo"
            text="Create Memo"
            onClick={this.clickCreateHandler}
            visible={true}
          />)}
      </div>
    );
  }

  onClickOpenEditor() {
    this.dataModel.onOpenEditor();
  }

  onClickClose() {
    this.dataModel.onCloseEditor();
  }

  onClickCreate() {
    this.dataModel.onCreateMemo();
  }

  onClickSave() {
    this.dataModel.onSaveChanges();
  }

  onClickRevert() {
    this.dataModel.onRevertChanges();
  }
}
